module.exports = __webpack_public_path__ + "img/stopwatch.c22c5fff.png";